import React, { useEffect, useState } from 'react';
import emailjs from '@emailjs/browser';

const Result = () => {
  return (
    <p className="success-message">Your message has been successfully sent. I will contact you soon.</p>
  );
};

function ContactForm({ formStyle }) {
  const [result, setResult] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Initialize EmailJS with your Public Key (User ID)
  useEffect(() => {
    emailjs.init('gkw4AfRT0IqnVSFSF'); // Your EmailJS Public Key
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = {
      subject: formData.get('subject') || 'WEBSITE FORM SUBMISSION',
      fullname: formData.get('fullname'),
      email: formData.get('email'),
      phone: formData.get('phone'),
      message: formData.get('message'),
    };

    emailjs
      .send('service_4a7wk96', 'template_b436u9a', data)
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setResult(true);
          e.target.reset(); // Reset form after successful submission
        },
        (error) => {
          console.error('FAILED...', error.text);
          setErrorMessage(`Failed to send email: ${error.text}`);
        }
      )
      .catch((error) => {
        console.error('Error:', error);
        setErrorMessage('An unexpected error occurred. Please check your network or EmailJS configuration.');
      });
  };

  useEffect(() => {
    if (result) {
      const timer = setTimeout(() => setResult(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [result]);

  return (
    <form className={formStyle} onSubmit={sendEmail}>
      <div className="form-group">
        <input type="text" name="fullname" placeholder="Your Name" required />
      </div>

      <div className="form-group">
        <input type="email" name="email" placeholder="Email Address" required />
      </div>

      <div className="form-group">
        <input type="text" name="phone" placeholder="Phone Number" required />
      </div>

      <div className="form-group">
        <input type="text" name="subject" placeholder="Subject" required />
      </div>

      <div className="form-group">
        <textarea name="message" placeholder="Your Message" required />
      </div>

      <div className="form-group">
        <button type="submit" className="btn-default btn-large">
          Submit Now
        </button>
      </div>

      <div className="form-group">
        {result && <Result />}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </form>
  );
}

export default ContactForm;